import React from 'react';
import { Route } from 'react-router';
import createCustomRoute from 'hocs/createCustomRoute';
import TableManagement from './components/TableManagement';
import TableManagementGroup from './components/TableManagementGroup';
import TableManagementMap from './components/TableManagementMap';
import TableManagementReport from './components/TableManagementReport';
import TableManagementVoidItemReport from './components/TableManagementVoidItemReport';

const TableManagementRoutes = createCustomRoute(
  'TableManagementRoutes',
  props => (
    <Route {...props} component={TableManagement}>
      <Route path="group" component={TableManagementGroup} />
      <Route path="map" component={TableManagementMap} />
      <Route path="report" component={TableManagementReport} />
      <Route
        path="void-item-report"
        component={TableManagementVoidItemReport}
      />
    </Route>
  )
);

export default TableManagementRoutes;
